'use client';

import classNames from 'classnames';
import type { HTMLAttributes, ReactNode, Ref } from 'react';

import twoRailsStyles from './ConversionBarTwoRails.module.scss';

import type { TwoRailsExperimentStatus } from '../hooks/useTwoRailsExperimentStatus';

type ConversionBarTwoRailsShellProps = {
  experimentStatus: TwoRailsExperimentStatus;
  defaultPanel: ReactNode;
  twoRailsPanel: ReactNode;
  twoRailsTestId: string;
  containerTestId?: string;
  defaultPanelTestId?: string;
  containerClassName?: string;
  defaultPanelClassName?: string;
  containerRef?: Ref<HTMLDivElement>;
  containerProps?: Omit<HTMLAttributes<HTMLDivElement>, 'className' | 'children'>;
};

export const ConversionBarTwoRailsShell: React.FC<ConversionBarTwoRailsShellProps> = ({
  experimentStatus,
  defaultPanel,
  twoRailsPanel,
  twoRailsTestId,
  containerTestId,
  defaultPanelTestId,
  containerClassName,
  defaultPanelClassName,
  containerRef,
  containerProps,
}) => {
  return (
    <div
      ref={containerRef}
      className={classNames(twoRailsStyles.container, containerClassName)}
      data-two-rails-experiment={experimentStatus}
      data-testid={containerTestId}
      {...containerProps}
    >
      <div className={defaultPanelClassName} data-two-rails-slot="default" data-testid={defaultPanelTestId}>
        {defaultPanel}
      </div>
      <div className={twoRailsStyles.twoRailsPanel} data-two-rails-slot="two-rails" data-testid={twoRailsTestId}>
        {twoRailsPanel}
      </div>
    </div>
  );
};
